import { LinkFallbackToast } from '@components'
import toast from 'react-hot-toast'
import { Trans } from 'react-i18next'

export const openLinkInTab = (link: string): void => {
  const newWin = window.open(link, '_blank')

  // CASE: Popup blocked :(
  if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
    toast(
      t => (
        <LinkFallbackToast
          href={link}
          onDismiss={() => toast.dismiss(t.id)}
          message={<Trans i18nKey="reports.popupBlocked" />}
          buttonLabel={<Trans i18nKey="reports.popupBlockedBtn" />}
        />
      ),
      {
        duration: 6000
      }
    )
  }

  // CASE: Autodownload worked
  else {
    newWin.focus()
  }
}
